/*
 * Module for KnowledgeBases
 */

define([
  "backbone",
  "marionette",
  "underscore",
  "messaging/messenger",
  "configuration/properties",
  "modules/accountAdmin/kbAdmin/kbAdminView",
  "modules/shared/sortableList/sortableListModule",
  "modules/accountAdmin/kbWizardModal/kbWizardModalModule",
  "modules/accountAdmin/kbAdmin/kbModel",
], function (
  Backbone,
  Marionette,
  _,
  Messenger,
  Properties,
  KbAdminView,
  SortableListModule,
  KbWizardModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "knowledgeBaseAdmin";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (options) {
      options = options || {};
      if (options.kbId) {
        this._loadKbs();
        this.kbs.onSynced(function () {
          let kbId = options.kbId;
          if (kbId == "new") {
            if (this.globalAdmin) {
              this._onAddKb();
              return;
            }
          }
          kbId = +kbId;
          if (kbId && !isNaN(kbId)) {
            const kb = this.kbs.get(kbId);
            if (kb) {
              Messenger.vent.trigger("show:admin:kbProfile", _.extend({ kb: kb }, options));
              return;
            }
          }
          Backbone.history.navigate("accountAdmin/kbs");
          this.show();
        }, this);
      } else {
        Backbone.history.navigate("accountAdmin/kbs");
      }
      this._loadKbs();

      Messenger.onSave(function () {
        if (this.knowledgeBase) {
          this.knowledgeBase.saveModel();
        } else {
          Messenger.saveAttempted(true); //success
        }
      }, this);

      // Stupid model just for readonly toggle
      const readOnlyModel = new Backbone.Model({ readOnly: !this.globalAdmin });

      this.layout = new KbAdminView.kbAdminLayout({ model: readOnlyModel });
      const headers = Messenger.reqres.request("kb:list:headers");

      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
        }),
      );

      this.layout.on(
        "show",
        function () {
          this.list.show(this.kbs);
        },
        this,
      );

      if (this.globalAdmin) {
        this.layout.on("add:kb", this._onAddKb, this);
      }

      this._showRegion();
    },
    _loadKbs: function () {
      this.globalAdmin = Messenger.reqres.request("user:is:global:admin");
      if (this.globalAdmin) {
        this.kbs = Messenger.reqres.request("admin:kbs");
        this.tenants = Messenger.reqres.request("tenants");
      } else {
        this.tenant = Messenger.reqres.request("active:tenant");
        this.kbs = Messenger.reqres.request("tenant:kbs", this.tenant.get("tenantId"));
      }
    },
    _onAddKb: function () {
      const modalBundle = {
        kbStep: "settings",
        item: this.kbs.addNewKb(),
      };
      Messenger.vent.trigger("show:modal", KbWizardModalModule, { editMode: false }, modalBundle, {
        title: "admin.kbAdmin.addKb",
        closeOnBackgroundClick: false,
        modalWidth: 1000,
        trackInteraction: {
          action: "Add Knowledge Base",
          object: "Knowledge Base",
        },
      });
    },
    _showRegion: function () {
      if (this.globalAdmin) {
        //Once the tenants and kbs are loaded, go through the kb list and set the name of its tenant so it can be
        //displayed and sorted on the table
        this.tenants.onSynced(function () {
          this.kbs.onSynced(function () {
            _.each(
              this.kbs.models,
              function (kb) {
                kb.tenantName = this.tenants
                  .findWhere({ tenantId: kb.get("tenantId") })
                  .get("tenantName");
              },
              this,
            );
            this.showRegion(this.layout);
          }, this);
        }, this);
      } else {
        this.tenant.onSynced(function () {
          this.kbs.onSynced(function () {
            _.each(
              this.kbs.models,
              function (kb) {
                kb.tenantName = this.tenant.get("tenantName");
              },
              this,
            );
            this.showRegion(this.layout);
          }, this);
        }, this);
      }
    },
    _setUpVents: function () {
      //Show the KB admin screen
      Messenger.vent.on("show:account:admin:kbs", this.show, this);

      Messenger.vent.on(
        this.name + ":selected:row",
        function (model) {
          Messenger.command.execute("set:active:kb", model.get("kbId"));
          Messenger.vent.trigger("show:kb:profile", { kb: model });
        },
        this,
      );

      Messenger.vent.on(
        "add:kb:defaults",
        function (kbId) {
          //create temporary backbone model to make the save
          const kbDefaultsModel = new Backbone.Model();
          kbDefaultsModel.url = function () {
            return Properties.rootURL + "/" + kbId + "/defaults";
          };
          kbDefaultsModel.save(null, {
            data: [],
            type: "POST",
            contentType: "application/json",
          });
        },
        this,
      );
    },
  });
});
